import React, { Component } from 'react';
import './AddNoticia.css';
import axios from 'axios';
import { BASE_HOST_URL } from '../../config';

class AddNoticia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      esTitle: '',
      esMessage: '',
      catTitle: '',
      catMessage: '',
      enTitle: '',
      enMessage: '',
      creating: false,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const { target: { name, value } } = event;
    this.setState({ [name]: value });
  }

  async createNew() {
    try {
      if (!this.state.esTitle) { alert('Falta título en español'); return; }
      if (!this.state.esMessage) { alert('Falta mensaje en español'); return; }

      if (!this.state.catTitle) { alert('Falta título en català'); return; }
      if (!this.state.catMessage) { alert('Falta mensaje en català'); return; }

      if (!this.state.enTitle) { alert('Falta título en english'); return; }
      if (!this.state.enMessage) { alert('Falta mensaje en english'); return; }

      this.setState({ creating: true });
      const new2upload = this.state;
      delete new2upload.creating;
      await axios.post(`${BASE_HOST_URL}/api/v1/news`, new2upload);
      this.setState({ creating: false });
      this.props.history.goBack();
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    return (
      <div className="createNewWrapper">
        <div className="actionWrapper">
          <button className="btnCreateNew" onClick={() => this.createNew()}>
            {
              this.state.creating
                ? 'CREANT...'
                : 'CREAR ARA'
            }
          </button>
        </div>
        <div className="contentWrapper">
          <div className="langCreateNew">
            <h3 className="nameLang">Español</h3>
            <div className="itemLang">
              <h5>Título</h5>
              <input name="esTitle" type="text" className="inputLang" onChange={this.handleChange}></input>
            </div>
            <div className="itemLang">
              <h5>Descripción</h5>
              <textarea name="esMessage" rows="4" type="text" className="inputLang" onChange={this.handleChange}></textarea>
            </div>
          </div>
          <div className="langCreateNew">
            <h3 className="nameLang">Català</h3>
            <div className="itemLang">
              <h5>Títol</h5>
              <input name="catTitle" type="text" className="inputLang" onChange={this.handleChange}></input>
            </div>
            <div className="itemLang">
              <h5>Descripció</h5>
              <textarea name="catMessage" rows="4" type="text" className="inputLang" onChange={this.handleChange}></textarea>
            </div>
          </div>
          <div className="langCreateNew">
            <h3 className="nameLang">English</h3>
            <div className="itemLang">
              <h5>Title</h5>
              <input name="enTitle" type="text" className="inputLang" onChange={this.handleChange}></input>
            </div>
            <div className="itemLang">
              <h5>Description</h5>
              <textarea name="enMessage" rows="4" type="text" className="inputLang" onChange={this.handleChange}></textarea>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddNoticia;



// WEBPACK FOOTER //
// ./src/components/AddNoticia/AddNoticia.js